import React, { useRef, useState } from 'react';
import {
	Wrapper,
	InfoWrapper,
	ButtonsWrapper,
	ItemWrapper,
	ColorSymbol,
	IconWrapper,
	TooltipContent,
	TooltipRow,
	RightColumn,
	TextWrapper,
} from './ProjectFooter.styles';
import {
	ApButtonIcon,
	ApButtonSecondary,
	ApIcon,
	ApPopover,
	colors,
} from '@alixpartners/ui-components';
import sortBy from 'lodash/sortBy';

const MAX_COMPANIES = 5;

export const ProjectFooter = ({ onReset, onExpand, companiesOptions }) => {
	const ref = useRef(null);
	const [isOpen, setOpen] = useState(false);
	const expandAll = () => {
		onExpand();
	};
	const collapseAll = () => {
		onExpand(false);
	};
	const toggleOpen = () => setOpen(!isOpen);

	const sortedCompaies = sortBy(
		companiesOptions.filter(item => item.mappedSpend > 0),
		'percentage'
	);
	const showMoreTooltip = sortedCompaies.length > MAX_COMPANIES;
	const visibleCompanies = showMoreTooltip
		? sortedCompaies.slice(0, MAX_COMPANIES - 1)
		: sortedCompaies;

	return (
		<Wrapper>
			<ButtonsWrapper>
				<ApButtonIcon iconName="unfold_more" onClick={expandAll} />
				<ApButtonIcon iconName="unfold_less" onClick={collapseAll} />
				<ApButtonSecondary onClick={onReset}>Reset</ApButtonSecondary>
			</ButtonsWrapper>
			<InfoWrapper>
				{visibleCompanies.map(({ percentage, color, value }) => {
					return (
						<ItemWrapper key={value}>
							<ColorSymbol color={color} />
							{percentage}%
						</ItemWrapper>
					);
				})}
				{showMoreTooltip && (
					<React.Fragment>
						<IconWrapper innerRef={ref} onClick={toggleOpen}>
							<ApIcon
								iconName="more_horiz"
								iconColor={isOpen ? colors.grey6 : colors.grey4}
							/>
						</IconWrapper>
						{isOpen && (
							<ApPopover
								referenceElement={ref.current}
								hideArrow
								onClose={toggleOpen}
								modifiers={{
									offset: { offset: '0, 20' },
								}}
							>
								<TooltipContent>
									{sortedCompaies.map(({ percentage, color, value, label }) => {
										return (
											<TooltipRow key={value}>
												<ColorSymbol color={color} />
												<TextWrapper>{label}</TextWrapper>
												<RightColumn>{percentage}%</RightColumn>
											</TooltipRow>
										);
									})}
								</TooltipContent>
							</ApPopover>
						)}
					</React.Fragment>
				)}
			</InfoWrapper>
		</Wrapper>
	);
};

export default ProjectFooter;
